import React from 'react';
import { GlobalFiltersContainer, FilterSelect, DateInput } from '../styles';

const FiltersSection = ({ pages, posts, mediaTypes, filtros, setFiltros }) => {
    
    const handleChange = (field, value) => {
        setFiltros(prev => ({ ...prev, [field]: value }));
    };

    return (
        <GlobalFiltersContainer>
            <h4>Filtros de Visualização:</h4>
            <div style={{display: 'flex', gap: '0.5rem', alignItems: 'center'}}>
                <span style={{fontSize: '0.9rem', color: '#666'}}>De:</span>
                <DateInput type="date" value={filtros.viewInicio} onChange={e => handleChange('viewInicio', e.target.value)} />
            </div>
            <div style={{display: 'flex', gap: '0.5rem', alignItems: 'center'}}>
                <span style={{fontSize: '0.9rem', color: '#666'}}>Até:</span>
                <DateInput type="date" value={filtros.viewFim} onChange={e => handleChange('viewFim', e.target.value)} />
            </div>

            <FilterSelect value={filtros.pagina} onChange={e => { handleChange('pagina', e.target.value); handleChange('post', 'todos'); }}>
                <option value="todas">Todas as Páginas</option>
                {pages.map(p => <option key={p.page_id} value={p.page_id}>{p.name}</option>)}
            </FilterSelect>

            <FilterSelect value={filtros.tipo} onChange={e => { handleChange('tipo', e.target.value); handleChange('post', 'todos'); }}>
                <option value="todos">Todos os Tipos (Feed e Reels)</option>
                {mediaTypes.map(type => <option key={type} value={type}>{type}</option>)}
            </FilterSelect>

            <FilterSelect value={filtros.post} onChange={e => handleChange('post', e.target.value)}>
                <option value="todos">Todos os Posts Listados</option>
                {posts.map(p => (
                    <option key={p.post_id} value={p.post_id}>
                        {p.media_product_type ? `[${p.media_product_type}] ` : ''} 
                        {p.caption ? p.caption.substring(0, 40) + '...' : p.post_id}
                    </option>
                ))}
            </FilterSelect>
        </GlobalFiltersContainer>
    );
};

export default FiltersSection;